import useSubmitStore from "stores/submit"
import useT from "utils/useT"

const PriceInput = ({ loading }: { loading: boolean }) => {
  const t = useT()
  const submitterPrice = useSubmitStore((state) => state.submitterPrice)

  return (
    <div className="card card-style">
      <div className="mb-0 d-flex justify-content-between m-3" dir={t.dir}>
        <h3 dir="auto" className="mb-3">{t.submit.price}</h3>
        <div className="rounded-sm input-style has-borders has-icon mb-4 d-flex align-items-center position-relative">
          <div
            className="btn btn-border btn-xs btn-full rounded-sm text-uppercase font-900 border-green-dark color-green-dark bg-theme d-flex"
          >
            {loading && (
              <div
                style={{ transform: "scale(0.4)", margin: "-8px -4px" }}
                className="d-flex justify-content-center"
              >
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
            {`$ ${submitterPrice || "0.00"}`}
          </div>

        </div>
      </div>
    </div>
  )
}

export default PriceInput
